<div class="dialog-button-group">
  <button
    mat-icon-button
    type="button"
    class="dialog-action-button"
    (click)="alternarModalExpandido()"
    [attr.aria-label]="modalExpandido ? 'Restaurar modal' : 'Expandir modal'"
    [matTooltip]="modalExpandido ? 'Restaurar' : 'Expandir'">
    <mat-icon>{{ modalExpandido ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
  </button>

  <button
    mat-icon-button
    type="button"
    class="dialog-action-button dialog-close-button"
    mat-dialog-close
    aria-label="Fechar"
    matTooltip="Fechar">
    <mat-icon>close</mat-icon>
  </button>
</div>
